module.exports = __webpack_public_path__ + "static/media/profile-picture-3.9a250e5c.jpg";